'use client';

import { IconHeartFilled } from '@/features/icons';
import formatLargeNumber from '@/utils/string-helpers/format-large-number';
import usePDPData from '../../_utils/use-pdp-data';
function WishlistCount() {
  const {
    data
  } = usePDPData();
  const wishlistCount = data?.addedToWishListCount;
  if (!wishlistCount || wishlistCount < 10) return null;
  return <div className='flex items-center gap-1 lg:gap-1.5' data-sentry-component="WishlistCount" data-sentry-source-file="wishlist-count.tsx">
            <IconHeartFilled className='h-4 w-4 text-primary-main lg:h-5 lg:w-5' data-sentry-element="IconHeartFilled" data-sentry-source-file="wishlist-count.tsx" />

            <span className='text-caption-12 text-text-mediumGray lg:text-body-14'>
                {formatLargeNumber(wishlistCount)} علاقه‌مندی
            </span>
        </div>;
}
export default WishlistCount;